import React from 'react';
import { useSelector } from 'react-redux';

import { getItem } from '../../selectors/item';
import { getControlMenu } from '../../selectors/media';

import type Item from '../../@types/item';
import { Lightbox } from '../../components/lightbox';
import { getConvertedMileage, getMarketOdometer } from '../../utils/market';

const getItemData = (item: Item) => {
  if (!item) return null;

  const odometer = item.odometerReading
    ? getMarketOdometer(item.odometerReading)
    : getConvertedMileage(item.mileage);

  return {
    price: item.price,
    privateLeasing: item.leasingPrice,
    businessLeasing: item.businessLeasingPrice,
    usps: [
      {
        icon: 'icon-mileage',
        value: odometer || '-',
      },
      {
        icon: 'icon-calendar',
        value: item.modelYear || '-',
      },
      {
        icon: 'icon-fuel',
        value: item.fuelTypes || '-',
      },
      {
        icon: 'icon-gearbox',
        value: item.gearboxType || '-',
      },
    ],
  };
};

type PropsType = {
  onClose: () => void;
  startIndex: number;
  children?: React.ReactNode | React.ReactNode[];
};

const LightboxShell: React.FunctionComponent<PropsType> = ({ onClose, startIndex, children }) => {
  const item = useSelector(getItem);
  const controlMenu = useSelector(getControlMenu);

  const scrollInto = (index: number) => {
    setTimeout(() => {
      const node: HTMLElement | null = document.querySelector(`#lightbox-item-${index}`);
      const containerMobile = document.querySelector('.lightbox-media-container');
      const containerDesktop = document.querySelector('[data-am-lightbox]');

      if (node && containerMobile && containerDesktop) {
        containerMobile.scrollTop = containerMobile.scrollTop = node.offsetTop;
        containerDesktop.scrollTop = containerDesktop.scrollTop = node.offsetTop;
      }
    }, 200);
  };

  React.useEffect(() => {
    scrollInto(startIndex);
  }, []);

  if (!item) return null;

  return (
    <Lightbox
      className="is-open"
      data={getItemData(item)}
      onClose={onClose}
      controlMenu={controlMenu}
      isOrder={item.inventoryStatusString === 'Order'}
    >
      {children || []}
    </Lightbox>
  );
};
export default LightboxShell;
